import { render, staticRenderFns } from "./ModalMediaInstagram.vue?vue&type=template&id=05bdbfab&scoped=true&"
import script from "./ModalMediaInstagram.vue?vue&type=script&lang=js&"
export * from "./ModalMediaInstagram.vue?vue&type=script&lang=js&"
import style0 from "./ModalMediaInstagram.vue?vue&type=style&index=0&id=05bdbfab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bdbfab",
  null
  
)

export default component.exports